import { Box } from '@mui/material';
import { useRef, useState } from 'react';

import { BackToTopButton } from '@/ui/components/button/BackToTopButton';
import { ColorsRaw } from '@/ui/theme/colors-raw';

import { scrollQuizPanelToTop } from './QuizPanel.utils';

export function QuizPanelLayout({
  children,
  panelOpen,
  setPanelOpen,
  disablePadding,
}: {
  children: React.ReactNode;
  panelOpen: boolean;
  setPanelOpen?: React.Dispatch<React.SetStateAction<boolean>>;
  disablePadding?: boolean;
}) {
  const [scrolled, setScrolled] = useState(false);
  const panelRef: React.RefObject<HTMLInputElement | undefined | null> =
    useRef();

  panelRef?.current?.addEventListener('scroll', () => {
    setScrolled(
      panelRef?.current?.scrollTop ? panelRef.current.scrollTop > 100 : false,
    );
  });

  return (
    <>
      <Box
        sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          display: panelOpen ? 'block' : 'none',
          minHeight: '100vh',
          height: '100%',
          backgroundColor: '#0A0A0C70',
        }}
        onClick={() => {
          if (panelOpen && setPanelOpen) setPanelOpen(false);
        }}
      />
      <Box position={'relative'}>
        {scrolled && (
          <BackToTopButton
            onClick={scrollQuizPanelToTop}
            sx={{
              position: 'fixed',
              bottom: 24,
              right: 24,
              zIndex: 999,
            }}
          />
        )}
      </Box>
      <Box
        ref={panelRef}
        sx={{
          width: panelOpen ? '40rem' : '21rem',
          height: '100vh',
          backgroundColor: ColorsRaw.anthracite.Anthracite_1,
          transition: 'all 0.5s ease-out',
          position: 'fixed',
          right: 0,
          top: 0,
          scrollbarWidth: 'none',
          '&::-webkit-scrollbar': { display: 'none' },
          overflowY: 'scroll',
          borderLeft: `1px solid ${ColorsRaw.anthracite.Anthracite_4}`,
        }}
        onClick={() => {
          if (!panelOpen && setPanelOpen) setPanelOpen(true);
        }}
      >
        <Box
          id="panel-top"
          sx={{
            padding: disablePadding ? 0 : 3,
            position: 'relative',
          }}
        >
          {children}
        </Box>
      </Box>
    </>
  );
}
